var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanIncludesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plan-includes-icon",
    transform: "translate(-0.351)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(0.351)",
    fill: "#cc8552",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Line",
    transform: "translate(23 24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M33.92,26.86l-4.05-2.2L25,45H36V30.37a4,4,0,0,0-2.081-3.51Z",
    transform: "translate(-3 -4)",
    fill: "#cc8552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M18,9a5,5,0,1,0-5,5,4.94,4.94,0,0,0,2.93-1,9,9,0,0,1,1.81-2.5A4.7,4.7,0,0,0,18,9Z",
    transform: "translate(-3 -4)",
    fill: "#cc8552"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(14.351 6)",
    fill: "#cc8552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M40,9A5,5,0,1,0,30,9a4.7,4.7,0,0,0,.26,1.54A9,9,0,0,1,32.07,13,4.94,4.94,0,0,0,35,14,5,5,0,0,0,40,9Z",
    transform: "translate(-3 -4)",
    fill: "#cc8552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M15,17a8.33,8.33,0,0,1,.11-1.33A7.1,7.1,0,0,1,13,16a7,7,0,0,1-4-1.25L5.6,16A4,4,0,0,0,3,19.77V34h7V30.37a6,6,0,0,1,3.13-5.26l4.07-2.23A9,9,0,0,1,15,17Z",
    transform: "translate(-3 -4)",
    fill: "#cc8552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M42.4,16,39,14.75A7,7,0,0,1,35,16a7.1,7.1,0,0,1-2.11-.33A8.33,8.33,0,0,1,33,17a9,9,0,0,1-2.2,5.88l4.07,2.23A6,6,0,0,1,38,30.37V34h7V19.77A4,4,0,0,0,42.4,16Z",
    transform: "translate(-3 -4)",
    fill: "#cc8552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M25,28v8.48l-1,4.2-1-4.2V28a1,1,0,0,1,2,0Z",
    transform: "translate(-3 -4)",
    fill: "#cc8552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M25,28v8.48l-1,4.2-1-4.2V28a1,1,0,0,1,2,0Z",
    transform: "translate(-3 -4)",
    fill: "#cc8552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M14.08,26.86A4,4,0,0,0,12,30.37V45H23L18.13,24.66Z",
    transform: "translate(-3 -4)",
    fill: "#cc8552"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanIncludesIcon);
export default __webpack_public_path__ + "static/media/plan-includes-icon.c0a2089ed317b060ad63f74050b164d7.svg";
export { ForwardRef as ReactComponent };